<template>

    <v-col
        cols="12"
        xl="3"
        lg="4"
        sm="6"
    >

        <v-card>
            <!--  
                TODO FIX: src reikšmė turi būti dinamis atlaso img arba default img                
            -->
            <v-img
                class="white--text align-end atlas-gallery-image"
                height="200px"
                :src="imgSrc"
            >
                <v-card-title>{{atlas["title"]}}</v-card-title>
            </v-img>

            <v-card-subtitle class="pb-0">{{atlas["createDate"]}}</v-card-subtitle>

            <v-card-text class="text--primary">
                <div>{{atlas["shortDescription"] | truncate(200, '...') }}</div>

                <br>

                <div><small>Tipas: {{atlas["atlasType"]}}</small></div>
                <div><small>Sukūrė: {{atlas["owner"]}}</small></div>
            </v-card-text>

            <v-card-actions>
                <v-btn color="blue" text>
                    <router-link v-bind:to="'/atlas/' + atlas['atlasID'] + '/view'" class="link">
                        Peržiūrėti
                    </router-link>
                </v-btn>
            </v-card-actions>
            
        </v-card>
    
    </v-col>

</template>

<script>
	import AtlasHelper from "../helpers/AtlasHelper";

	export default {
		props: {
			atlas: Object,
			getList: Function,
			editable: Boolean
		},
		data: function(){
			var imgSrc;
			if (this.atlas.images && this.atlas.images.length) {
				imgSrc = AtlasHelper.getImageUrl(this.atlas.atlasID, this.atlas.images[0].atlasImageID);
			}
			var data = {
				deleteInAction: false,
				imgSrc: imgSrc
			};
			return data;
		}
    };
    
</script>

<style scoped>

	.link {
		color: inherit;
		text-decoration: none;
	};

</style>